module.exports = __webpack_public_path__ + "img/business_receive_02.png";